const initialState = {
    gridData:null,
};

const gridDataReducer =(state = initialState, action)=>{
    if (action.type === "gridData"){
        return { ...state, gridData: action.value};
    }

    return state;
};

export default gridDataReducer;